export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";